import React from 'react';
import styles from './FooterPage.module.scss';
import logo from '../../../../../assets/images/positivo.svg'

const IconText: React.FC = () => {
    return(
        <img src={logo} className={styles['iconText']} />
    )
}

const UHCFooter: React.FC = () => {

    return (
        <footer className={styles["footer"]}>
            <div className={styles['containerGeral']}>
                <p className={styles['text']}>UOL - O melhor conteúdo. Todos os direitos reservados.</p>
            </div>
        </footer>

    );
};

export default UHCFooter;